var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "m9.625 13.7.9-2.875-2.375-1.85h2.9L12 6l.925 2.975h2.925l-2.375 1.85.875 2.875L12 11.925zM6.1 23v-7.6q-1.125-1.175-1.612-2.575A8.5 8.5 0 0 1 4 10q0-3.4 2.3-5.7T12 2t5.7 2.3T20 10q0 1.425-.488 2.825-.487 1.4-1.612 2.575V23L12 21.025zm5.9-6.5q2.725 0 4.613-1.887Q18.5 12.725 18.5 10t-1.887-4.612T12 3.5 7.388 5.388 5.5 10t1.888 4.613T12 16.5"
  })));
};
export default SvgAward;